export default {
    ok: "Potvrdi",
    cancel: "Poništi",
    areYouSure: "Da li ste sigurni?",
    cantRevert: "Nećete moći da vratite ove podatke.",
};
